import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// Components
const DashboardUser = Loadable(lazy(() => import("views/user/dashboard")));
const UserFormDetails = Loadable(
  lazy(() => import("views/user/form-submit-details/FormSubmitDetails"))
);
const PaymentPrompt = Loadable(
  lazy(() => import("views/user/payment-prompt/PaymentPrompt"))
);
const SlipUpload = Loadable(
  lazy(() => import("views/user/slip-upload/SlipUpload"))
);
const InvoicesAndProjectDetails = Loadable(
  lazy(() => import("views/user/challanList-projectDetails"))
);
const ChallanForm = Loadable(lazy(() => import("views/user/challan-form")));

// ==============================|| MAIN ROUTING ||============================== //

const DashboardWithCheck = () => {
  const { isFormSubmitted } = useSelector((state: any) => state.FormSubmitted);

  if (isFormSubmitted === 1) {
    return <Navigate to="/user/invoices-and-projectdetails" />;
  } else if (isFormSubmitted === 2) {
    return <Navigate to="/user/slip-upload" />;
  }

  return <DashboardUser />;
};

const UserRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/user/dashboard",
      element: <DashboardWithCheck />,
    },
    {
      path: "/user/payment-prompt",
      element: <PaymentPrompt />,
    },
    {
      path: "/user/form-details",
      element: <UserFormDetails />,
    },
    {
      path: "/user/slip-upload",
      element: <SlipUpload />,
    },
    {
      path: "/user/challan-upload",
      element: <ChallanForm />,
    },
    {
      path: "/user/invoices-and-projectdetails",
      element: <InvoicesAndProjectDetails />,
    },
  ],
};

export default UserRoutes;
